module.exports = __webpack_public_path__ + "static/img/dehydration-01.e7ff6df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/dehydration-01.jpg
// module id = 259
// module chunks = 1